export default {
  fontSize: '16px',
  fontSizeSmall: '14px',
  fontSizeXSmall: '12px',
  Helvetica: 'Helvetica',
  Arial: 'Arial',
  primaryFont: 'NeurialGrotesk, Helvetica, Arial',
  secondaryFont: 'NeurialGrotesk, Helvetica, Arial',
  lineHeightH2: '48px'
};
//# sourceMappingURL=fonts.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/styles/fonts.js
// module id = 798
// module chunks = 0